// 빌드: ./fe-build.sh voice
import 'es6-promise/auto'
import Vue from 'vue'
import Axios from 'axios'
import Pager from './components/common/pagingUser.vue';
import Common from './components/ynadmin/common/common.js';
import swal from 'sweetalert';
import Editor from "./components/common/editor.vue";
import validation from 'validator';
import VueFileAgent from 'vue-file-agent';
import 'vue-file-agent/dist/vue-file-agent.css';
import Share from './components/common/share.js';
import mobile from 'is-mobile';
import DropImg from "./components/common/dragImgFile.vue";
import DropDoc from "./components/common/dragDocFile.vue";
import DropVideo from "./components/common/dragVideoFile.vue";
import SwalAlert from "./components/common/swalAlert.vue";

Vue.use(VueFileAgent);
Vue.use(mobile);

Vue.component("pager", Pager);
Vue.component('editor', Editor);
Vue.component('dropimg', DropImg);
Vue.component('dropdoc', DropDoc);
Vue.component('dropvideo', DropVideo);

Vue.prototype.$http = Axios;
Vue.prototype.$pager = Pager;
Vue.prototype.$common = Common;

const VOICE_SUGGEST_STATE_KEY = 'voiceSuggestListState';
const VOICE_SUGGEST_BACK_INTENT_KEY = 'voiceSuggestBackIntent';
const POLICY_NOTICE_STATE_KEY = 'policyNoticeListState';
const POLICY_NOTICE_BACK_INTENT_KEY = 'policyNoticeBackIntent';
const POLICY_CONTEST_STATE_KEY = 'policyContestListState';
const POLICY_CONTEST_BACK_INTENT_KEY = 'policyContestBackIntent';
const POLICY_EVENT_STATE_KEY = 'policyEventListState';
const POLICY_EVENT_BACK_INTENT_KEY = 'policyEventBackIntent';

new Vue({
  el: '#policy',
  data: function () {
    return {
      mainName: '청소년 정책참여',
      showAcc: '',
      isShare: false,
      isDeclare: false,
      declareList: [],
      declareReportCode: '',
      declareReportEtc: '',
      isMobile: false,
      fpt: '',
      listBanner: [],
      inputLabel: '',
      navName: '',
      tabIdx: '',
      currentUsrKey: '', // 현재 로그인한 사용자 Key 추가

      selectVoiceModelType: '',
      suggLi: '',

      isMobileStyle: {
        'width': '100%',
        //'height' : '250px'
        'height': 'auto'
      },
      isMobileStyles: {
        'height': 'auto'
      },

      insertVoice: {
        brdSubCtg: '',
        title: '',
        keyword: '',
        content1: '', //내용
        content2: '', //제안배경
        content3: '', //기대효과
        link: '',
        doc: ''
      },

      insertSenate: {
        title: '',
        content1: '', //내용
        keyword: '',
        fileKey: '',
      },

      selectYearModel: '',

      searchModel: {
        brdSubCtg: '',
        searchKeyword: '',
        searchYear: '',
        tab: '',
        brdUidKey: ''
      },

      mainListModel: {
        commisslist: [],
        senatelist: [],
        areaGuid: 'all',
        totalCount: 0,
        showMore: false,
      },

      noticeListModel: {
        list: [],
        kword: '',
        totalCount: 0,
        showMore: true,
        pager: {
          model: {},
          pageNo: 1,
          pageNum: 1,
          totalSize: 0,
          rowSize: 10,
          blockSize: 5,
          endSize: 0,
          list: [],
          href: "javascript:void(0);",
          callBack: function (n) {
            this.model.fnGetPolicyNoticeList(n);
          }
        }
      },

      senateDetailModel: {
        detail: {},
        prev: {},
        next: {},
        fileEtcList: [],
        fileImgList: [],
        fileVdList: []
      },

      eventListModel: {
        list: [],
        totalCount: 0,
        showMore: true,

        pager: {
          model: {},
          pageNo: 1,
          pageNum: 1,
          totalSize: 0,
          rowSize: 5,
          blockSize: 5,
          endSize: 0,
          list: [],
          href: "javascript:void(0);",
          callBack: function (n) {
            let searchid = $(".on").attr("id");

            this.model.fnGetPolicyEventList(n);
          }
        }
      },

      noticeDetailModel: {
        detail: {},
        prev: {},
        next: {},
        fileEtcList: [],
        fileImgList: [],
        fileVdList: []
      },

      viewModel:{
        admit1: false,
        admit2: false,
        list:[],
        detail:[],
        target:[],
        targetName : '',
        totalCount:0,
        checkedValues:[],
        programType : 'program',
        voiceTab: 'insertDate',
        pager: {
          model: {},
          pageNo: 1,
          pageNum: 1,
          totalSize: 0,
          rowSize: 10,
          blockSize: 5,
          endSize: 0,
          list: [],
          href: "javascript:void(0);"
        },
        showMore:true,
        showMore1:true,
        showMore2:true,
        zf:1,
        zt:1,
        boardPager: {
          model: {},
          pageNo: 1,
          pageNum: 1,
          totalSize: 0,
          rowSize: 5,
          blockSize: 5,
          endSize: 0,
          list: [],
          href: "javascript:void(0)",
          class: 'paging_blue',
          etc: '',
          callBack: function (n) {
            let _etc = this.model.viewModel.boardPager.etc;
            if (_etc == 'selectNoticeList') {
              this.model.fnGetPolicyNoticeList(n);
            }
          }
        },
        codeList: [],
        sortList: [],
        yearList: [],
        hotIssueList: [],
        voiceSuggestList: [],
        proposalList: [],
        contest: [],
        fileEtcList: [],
        fileImgList: [],
        fileVdList: [],
        // like/report 상태 및 리스트
        isLike: false,
        isReport: false,
        reportList: [],
        reportCodeList: []
      },
      isVoiceSuggestRestored: false,
      isPolicyNoticeRestored: false,
      isPolicyContestRestored: false,
      isPolicyEventRestored: false,
      insertReplyModel: {
        brdUidKey: '',
        replyContent: ''
      },
      insertReReplyModel: {
        brdUidKey: '',
        replyContent: ''
      },
      updateReplyModel: {
        brdUidKey: '',
        replyUidKey: '',
        replyContent: ''
      },
      updateReReplyModel: {
        brdUidKey: '',
        replyUidKey: '',
        replyContent: ''
      },
      insertVoiceReport: {
        reportValue: '',
        reportEtcValue: ''
      },

      mentoGroupModel: {
        mentoList: [{tesxt: ' '}],
        mentoContentsList: [{tesxt: ' '}],
        replyList: [{tesxt: ' '}],
        reportList: [{tesxt: ' '}],
        replyDepthZero: [{tesxt: ' '}],
        replyDepthOne: [{tesxt: ' '}],
        docList: [],
        imgList: [],
        vdList: [],
        mentoVO: {},
        postingVO: {},
        contentVO: {
          fileEtcList: [],
          fileImgList: [],
          fileVdList: []
        },
        eventVO: {},
        userKey: '',
        boardUid: '',
        reportValues: '',
        reportEtcValue: '',
        replyName: '',
        replyPassword: '',
        replyContents: '',
        replyUpdateContents: '',
        checkUidKey: '',
        inputPassword: '',
        isActionOption: 0,
        tab: 0,
        replyUidKey: 0,
        replyStarCnt: 0,
        replyCnt: 0,
        isIntro: false,
        isContents: false,
        isReplyOn: false,
        isReplyUpdateOn: false,
        isReReplyOn: false,
        isReReplyUpdateOn: false,
        isReportOn: false,
        isPassword: false,
        isButtonAction: true,
        isHideEventBtn: true // 이벤트 참여하기 버튼 감추기 여부
      },

      replyModel: {
        replyList: [],
        rereplyList: [],
        replyName: '',
        userKey: '',
        modifyTarget: '',
        modifyContents: '',
        replyPassword: '',
        replyContents: '',
        replyStarCnt: '',
        reReplyTarget: '',
        reReplyContents: ''
      },
    }
  },
  created: function () {
    this.isMobile = mobile();
    if (!('$' in Vue.prototype) && '$' in window) {
      Vue.prototype.$ = window.$; // <template> 에서 $ 사용
    }
  },
  mounted: function () {
    try {
      this.$nextTick(function () {
        // 현재 로그인한 사용자 정보 설정
        this.currentUsrKey = $("#usrKey").val() || '';

        // JSP onclick 호환을 위한 전역 브리지
        window.vueObj = this;
        window.fnSetReport = (kind) => { try { this.fnSetReport(kind); } catch(e){ console.log(e);} };
        window.fnSetReport1 = () => { try { this.fnSetReport1(); } catch(e){ console.log(e);} };
        window.fnShowReportWrite = () => { try { this.fnShowReportWrite(); } catch(e){ console.log(e);} };

        const currentUrl = window.location.pathname;
        
        // 시민청원 제안 목록 복원 체크 (proposalDetail에서 온 경우만)
        if (currentUrl === '/customer/policy/proposal') {
          const nav = performance.getEntriesByType('navigation')[0];
          const isBack = nav && (nav.type === 'back_forward');
          const ref = document.referrer || '';
          const fromProposalDetail = ref.indexOf('/customer/policy/proposalDetail') >= 0;
          const hasBackIntent = sessionStorage.getItem(VOICE_SUGGEST_BACK_INTENT_KEY) === 'true';

          if ((isBack || fromProposalDetail) && hasBackIntent) {
            this.restoreVoiceSuggestState();
            return;
          }
        }

        // 정책 공지 목록 복원 체크 (noticeDetail에서 온 경우만)
        if (currentUrl === '/customer/policy/notice') {
          const nav = performance.getEntriesByType('navigation')[0];
          const isBack = nav && (nav.type === 'back_forward');
          const ref = document.referrer || '';
          const fromNoticeDetail = ref.indexOf('/customer/policy/noticeDetail') >= 0;
          const hasBackIntent = sessionStorage.getItem(POLICY_NOTICE_BACK_INTENT_KEY) === 'true';

          if ((isBack || fromNoticeDetail) && hasBackIntent) {
            this.restorePolicyNoticeState();
            return;
          }
        }

        // 공모전 목록 복원 체크 (contestDetail에서 온 경우만)
        if (currentUrl === '/customer/policy/contest') {
          const nav = performance.getEntriesByType('navigation')[0];
          const isBack = nav && (nav.type === 'back_forward');
          const ref = document.referrer || '';
          const fromContestDetail = ref.indexOf('/customer/policy/contestDetail') >= 0;
          const hasBackIntent = sessionStorage.getItem(POLICY_CONTEST_BACK_INTENT_KEY) === 'true';

          if ((isBack || fromContestDetail) && hasBackIntent) {
            this.restorePolicyContestState();
            return;
          }
        }

        // 이벤트 목록 복원 체크 (eventDetail에서 온 경우만)
        if (currentUrl === '/customer/policy/event') {
          const nav = performance.getEntriesByType('navigation')[0];
          const isBack = nav && (nav.type === 'back_forward');
          const ref = document.referrer || '';
          const fromEventDetail = ref.indexOf('/customer/policy/eventDetail') >= 0;
          const hasBackIntent = sessionStorage.getItem(POLICY_EVENT_BACK_INTENT_KEY) === 'true';

          if ((isBack || fromEventDetail) && hasBackIntent) {
            this.restorePolicyEventState();
            return;
          }
        }

        // 복원이 아닌 경우에만 일반 초기화 수행
        pageLoad(this);
        this.fnOnLoadInit();

        // Kakao SDK 초기화 (이미 포함되어 있으나 미초기화 상태일 수 있음)
        try {
          if (typeof Kakao !== 'undefined' && Kakao && (!Kakao.isInitialized || (Kakao.isInitialized && !Kakao.isInitialized()))) {
            Kakao.init("25727a9190252a67c490a909452aecd8");
          }
        } catch (e) {
          console.log('Kakao init skipped:', e);
        }

        // 상세 페이지일 경우 신고/좋아요 초기 상태 로드
        if (document.querySelector('#brdUidKey')) {
          try {
            this.fnGetReportCodeList();
            this.fnGetVoiceReportList();
          } catch (e) { console.log(e); }
        }
      });
    } catch (e) {
      console.log(e);
    }
  },
  filters: {
    currency: function (value) {
      let num = new Number(value);
      return num.toFixed(0).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,");
    }
  },
  computed: {
    canEdit: function() {
      let authorUsrKey = this.viewModel.detail ? this.viewModel.detail.usrKey : null;
      return this.currentUsrKey && this.currentUsrKey !== '' && this.currentUsrKey === authorUsrKey;
    }
  },
  methods: {
    clickFunc: function (event) {
      event.target.focus();
    },
    fnOnLoadInit:function(){
      let vm = this;
      vm.fnSetCode("RPTNVYTHNV00000");
    },
    fnOnPolicyMainList: function (tabIdx) {
      let vm = this;
      this.tabIdx = tabIdx;

      const param = { };
      // vm.funLocationBarUpdate({pageNum: pageNumber, qnaType: null})
      Axios.post("/customer/policy/mainlist", param).then(function (response) {
        vm.mainListModel.commisslist = [];
        vm.mainListModel.senatelist = [];

        vm.mainListModel.commisslist = vm.mainListModel.commisslist.concat(response.data.commisslist);
        vm.mainListModel.senatelist = vm.mainListModel.senatelist.concat(response.data.senatelist);
      }).catch(function (ex) {
        console.log(ex);
      });
    },
    fnGoSenateMain: function(category)
    {
      let vm = this;

      if (category == "SENATE003")
      {
        location.href = "/customer/policy/senateNotice";
      }
      else
      {
        location.href = "/customer/policy/senate?tabIdx=" + category;
      }
    },
    fnOnPolicySenateMain: function(tabIdx, cmmUid)
    {
      let vm = this;
      vm.tabIdx = tabIdx;

      let param = {
        cmmUid: cmmUid
      };

      Axios.post("/customer/policy/senate/detail", param).then(function (response) {
        if(tabIdx == "SENATE001")
        {
          vm.mainListModel.commisslist = [];
          vm.mainListModel.commisslist = vm.mainListModel.commisslist.concat(response.data.senateDetail);
        }
        else if(tabIdx == "SENATE002")
        {
          vm.mainListModel.senatelist = [];
          vm.mainListModel.senatelist = vm.mainListModel.senatelist.concat(response.data.senateDetail);
        }
      }).catch(function (ex) {
        console.log(ex);
      });
    },
    fnSetSenateSuggest: function () {
      let vm = this;

      if ($("#usrKey").val() == null || $("#usrKey").val() == "") {
        swal("로그인이 필요합니다.").then(function(){
          location.href='/customer/account/login';
        });
        return false;
      }

      if (validation.isEmpty(vm.insertSenate.title)) {
        swal("제목을 입력해주세요.").then(function(){
          $('#insertSenateTitle').focus();
        });
        return false;
      } else if (!validation.isLength(vm.insertSenate.title, 0, 200)) {
        swal("제목이 너무 깁니다.").then(function(){
          $('#insertSenateTitle').focus();
        });
        return false;
      } else if (validation.isEmpty(vm.insertSenate.content1)) {
        swal("내용을 입력해주세요.").then(function(){
          $("html, body").animate({scrollTop: $("#insertSenateContent1").offset().top-200}, 100);
        });
        return false;
      }

      // 새로운 API 형식에 맞게 데이터 구성
      let detailObj = {
        category: 'BRDNVYTHNV06000',
        subCategory: 'BRDNVSUBNV00100',
        title: vm.insertSenate.title,
        content: vm.insertSenate.content1,
        delYn: 'N',
        fileKey: $("#fileKey").val(),
        usrKey: $("#usrKey").val(),
        usrId: $("#usrId").val(),
        keyword: vm.insertSenate.keyword || ''
      };

      let param = {
        paramText: JSON.stringify(detailObj)
      };

      swal({
        text : "참여기구제안을 등록하시겠습니까?",
        icon : "info",
        closeOnClickOutside : false,
        buttons : {
          confirm : {
            text : "확인",
            value : true
          }
          ,cancle : {
            text : "취소",
            value : false
          }
        },
        dangerMode: false
      }).then(function(isConfirm) {
        if (isConfirm) {
          // API 엔드포인트 변경 (/api/notice/creaete/board)
          Axios.post("/customer/policy/insertSenate", param).then(function (response) {
            console.log(response);
            let _cnt = response.data.resultCnt;
            if (_cnt > 0) {
              swal({
                title: '등록 완료',
                text: '정상 등록되었습니다.',
                buttons: {
                  confirm: {
                    text: "확인",
                    value: true,
                    visible: true,
                  },
                },
                dangerMode: false
              }).then(result => {
                if (result) {
                  window.history.back();
                }
              });
            } else {
              swal({
                title: '등록 실패',
                text: '등록에 실패하였습니다.',
                buttons: {
                  confirm: {
                    text: "확인",
                    value: true,
                    visible: true,
                  },
                },
                dangerMode: false
              });
            }
          }).catch(function (ex) {
            console.log(ex);
            swal({
              title: '오류 발생',
              text: '처리 중 오류가 발생했습니다.',
              buttons: {
                confirm: {
                  text: "확인",
                  value: true,
                  visible: true,
                },
              },
              dangerMode: false
            });
          });
        } else {
          return false;
        }
      });
    },

    fnOnPolicySenateList: function () {
      let vm = this;

      vm.tabIdx = $("#tabIdx").val();

      const param = {
        pageNo: vm.viewModel.pager.pageNo,
        pageSize: vm.viewModel.pager.rowSize,
        kind: vm.tabIdx
      };

      // vm.funLocationBarUpdate({pageNum: pageNumber, qnaType: null})
      Axios.post("/customer/policy/senate/list", param).then(function (response) {
        vm.viewModel.list = [];

        vm.viewModel.pager.totalSize = response.data.totalCount;
        vm.viewModel.pager.pageNum = (vm.viewModel.pager.pageNo * vm.viewModel.pager.rowSize) - vm.viewModel.pager.rowSize;
        Pager.props = Pager.methods.createPager(vm.viewModel.pager, vm, "list");

        vm.viewModel.list = vm.viewModel.list.concat(response.data.senatelist);
      }).catch(function (ex) {
        console.log(ex);
      });
    },
    fnOnPolicySenateDetail() {
      let vm = this;
      vm.tabIdx = $("#tabIdx").val();

      let param = {
        cmmUid: $("#cmmUid").val()
      };

      Axios.post("/customer/policy/senate/detail", param).then(function (response) {

        vm.senateDetailModel.detail = response.data.senateDetail;
        document.title = response.data.senateDetail.centerName;

      }).catch(function (ex) {
        console.log(ex);
      });
    },

    fnOnPostList: function (pageNumber) {
      // console.log(`fnOnPostList() pageNumber = ${pageNumber}`)
      const vm = this;
      if (pageNumber < 2) vm.noticeListModel.list = [];
      vm.noticeListModel.pager.pageNo = pageNumber;

      const param = {
        pageNo: vm.noticeListModel.pager.pageNo,
        pageSize: vm.noticeListModel.pager.rowSize,
        kind: '',
        kword: vm.noticeListModel.kword,
      };

      // vm.funLocationBarUpdate({pageNum: pageNumber, qnaType: null})
      Axios.post("/customer/policy/notice/list", param).then(function (response) {

        vm.noticeListModel.pager.totalSize = response.data.totalCount;
        vm.noticeListModel.pageNum = (vm.noticeListModel.pager.pageNo * vm.noticeListModel.pager.rowSize) - vm.noticeListModel.pager.rowSize;
        Pager.props = Pager.methods.createPager(vm.noticeListModel.pager, vm, "list");

        vm.noticeListModel.list = vm.noticeListModel.list.concat(response.data.noticeList);

        if (response.data.totalCount == vm.noticeListModel.list.length) {
          vm.noticeListModel.showMore = false;
        } else {
          vm.noticeListModel.showMore = true;
        }

        // 상태 저장
        vm.savePolicyNoticeState();

      }).catch(function (ex) {
        console.log(ex);
      });
    },

    // 시민청원 제안 목록 상태 저장
    saveVoiceSuggestState: function () {
      try {
        const state = {
          proposalList: this.viewModel.proposalList,
          totalCount: this.viewModel.totalCount,
          pager: {
            pageNo: this.viewModel.pager.pageNo,
            rowSize: this.viewModel.pager.rowSize
          },
          searchModel: {
            brdSubCtg: this.searchModel.brdSubCtg,
            searchKeyword: this.searchModel.searchKeyword,
            searchYear: this.searchModel.searchYear,
            tab: this.searchModel.tab
          },
          selectYearModel: this.selectYearModel,
          voiceTab: this.viewModel.voiceTab,
          showMore: this.viewModel.showMore,
          scrollY: window.scrollY,
          timestamp: Date.now()
        };
        sessionStorage.setItem(VOICE_SUGGEST_STATE_KEY, JSON.stringify(state));
      } catch (e) {
        console.error('Failed to save voice suggest list state:', e);
      }
    },

    // 시민청원 제안 목록 상태 복원
    restoreVoiceSuggestState: function () {
      try {
        const savedState = sessionStorage.getItem(VOICE_SUGGEST_STATE_KEY);
        if (!savedState) {
          this.$nextTick(function () {
            pageLoad(this);
          });
          return;
        }

        const state = JSON.parse(savedState);
        const TTL = 15 * 60 * 1000; // 15분

        if (Date.now() - state.timestamp > TTL) {
          sessionStorage.removeItem(VOICE_SUGGEST_STATE_KEY);
          sessionStorage.removeItem(VOICE_SUGGEST_BACK_INTENT_KEY);
          this.$nextTick(function () {
            pageLoad(this);
          });
          return;
        }

        this.viewModel.proposalList = state.proposalList || [];
        this.viewModel.totalCount = state.totalCount || 0;
        this.viewModel.pager.pageNo = state.pager && state.pager.pageNo ? state.pager.pageNo : 1;
        this.viewModel.pager.rowSize = state.pager && state.pager.rowSize ? state.pager.rowSize : this.viewModel.pager.rowSize;
        this.viewModel.pager.totalSize = state.totalCount || 0;

        if (state.searchModel) {
          this.searchModel.brdSubCtg = state.searchModel.brdSubCtg || '';
          this.searchModel.searchKeyword = state.searchModel.searchKeyword || '';
          this.searchModel.searchYear = state.searchModel.searchYear || '';
          this.searchModel.tab = state.searchModel.tab || '';
        }

        if (state.selectYearModel) {
          this.selectYearModel = state.selectYearModel;
        }

        this.viewModel.voiceTab = state.voiceTab || this.viewModel.voiceTab;
        this.viewModel.showMore = state.showMore !== undefined ? state.showMore : true;

        const savedScrollY = state.scrollY || 0;

        this.$nextTick(function () {
          // 복원 시에는 초기화만 수행하고 API 호출은 스킵
          this.fnVoiceSuggestTab(this.searchModel.tab || 'insertDate');
          this.fnGetCodeList();
          this.fnGetYearList();
          
          // Pager 객체 재생성 (페이지 네비게이션 복원)
          this.viewModel.pager.pageNum = (this.viewModel.pager.pageNo * this.viewModel.pager.rowSize) - this.viewModel.pager.rowSize;
          Pager.props = Pager.methods.createPager(this.viewModel.pager, this, "list");
          
          setTimeout(function () {
            window.scrollTo(0, savedScrollY);
          }, 100);
        });

        sessionStorage.removeItem(VOICE_SUGGEST_BACK_INTENT_KEY);

        console.log('Voice suggest list state restored from session storage');
      } catch (e) {
        console.error('Failed to restore voice suggest list state:', e);
        sessionStorage.removeItem(VOICE_SUGGEST_STATE_KEY);
        sessionStorage.removeItem(VOICE_SUGGEST_BACK_INTENT_KEY);
        this.$nextTick(function () {
          pageLoad(this);
        });
      }
    },

    fnGoChallengeMain: function (tabIdx) { //시민청원 청소년 시민청원 현황/Live 제안 페이지
      if (tabIdx === undefined) tabIdx = "EVENT";
      if (tabIdx == "EVENT")
      {
        location.href = '/customer/policy/event';
      }
      else if (tabIdx == "CONTEST")
      {
        location.href = '/customer/policy/contest';
      }
      else if (tabIdx == "NOTICE")
      {
        location.href = '/customer/policy/notice';
      }
    },

    fnGetPolicyNoticeList: function (pageNumber) {
      let vm = this;
      vm.noticeListModel.pager.pageNo = pageNumber ? pageNumber : 1;

      let brdCtg = $("#brdCtg").val();
      let brdSubCtg = $("#brdSubCtg").val();
      let param = {};

      param.brdCtg = brdCtg;
      param.brdSubCtg = brdSubCtg;
      param.pageNo = vm.noticeListModel.pager.pageNo;
      param.pageSize = vm.noticeListModel.pager.rowSize;

      if (vm.searchModel.searchKword != null && vm.searchModel.searchKword != "") {
        param.searchKeyword = vm.searchModel.searchKword.trim();
      }

      // 복원 완료 상태라면 최초 한 번은 API 호출 스킵
      if (vm.isPolicyNoticeRestored) {
        vm.isPolicyNoticeRestored = false;
        return;
      }

      Axios.post("/customer/policy/notice/list", param).then(function (response) {
        vm.noticeListModel.list = vm.noticeListModel.list.concat(response.data.list);

        if(response.data.totalCount == vm.noticeListModel.list.length) {
          vm.noticeListModel.showMore = false;
        } else {
          vm.noticeListModel.showMore = true;
        }

        vm.noticeListModel.totalBoardCount = response.data.totalCount;
        vm.noticeListModel.pager.totalSize = vm.noticeListModel.totalBoardCount;
        vm.noticeListModel.pager.pageNum = (vm.noticeListModel.pager.pageNo * vm.noticeListModel.pager.rowSize) - vm.noticeListModel.pager.rowSize;

        Pager.props = Pager.methods.createPager(vm.noticeListModel.pager, vm, "list");

        // 상태 저장
        vm.savePolicyNoticeState();
      }).catch(function (ex) {
        console.log(ex);
      });
    },
    fnGetNoticeBoardDetail() {
      let vm = this;
      let param = {
        uidKey: $("#brdUidKey").val()
      };

      // 상세 페이지 진입 시 backIntent 설정
      sessionStorage.setItem(POLICY_NOTICE_BACK_INTENT_KEY, 'true');

      Axios.post("/customer/policy/notice/detail", param).then(function (response) {

        vm.viewModel.detail = response.data.detail;
        vm.viewModel.fileEtcList = response.data.fileEtcList;

        vm.viewModel.fileEtcList.forEach(function (file) {
          file.fileUrl = "/doc/" + file.file_new_name.substr(0, 8) + "/" + file.file_new_name;
        });

        document.title = response.data.detail.title;

      }).catch(function (ex) {
        console.log(ex);
      });
    },

    // 정책 공지 목록 상태 저장
    savePolicyNoticeState: function () {
      try {
        const state = {
          list: this.noticeListModel.list,
          totalCount: this.noticeListModel.totalCount,
          totalBoardCount: this.noticeListModel.totalBoardCount,
          pager: {
            pageNo: this.noticeListModel.pager.pageNo,
            rowSize: this.noticeListModel.pager.rowSize
          },
          kword: this.noticeListModel.kword,
          searchKword: this.searchModel.searchKword,
          scrollY: window.scrollY,
          timestamp: Date.now()
        };
        sessionStorage.setItem(POLICY_NOTICE_STATE_KEY, JSON.stringify(state));
      } catch (e) {
        console.error('Failed to save policy notice list state:', e);
      }
    },

    // 정책 공지 목록 상태 복원
    restorePolicyNoticeState: function () {
      try {
        const savedState = sessionStorage.getItem(POLICY_NOTICE_STATE_KEY);
        if (!savedState) {
          this.$nextTick(function () {
            pageLoad(this);
          });
          return;
        }

        const state = JSON.parse(savedState);
        const TTL = 15 * 60 * 1000; // 15분

        if (Date.now() - state.timestamp > TTL) {
          sessionStorage.removeItem(POLICY_NOTICE_STATE_KEY);
          sessionStorage.removeItem(POLICY_NOTICE_BACK_INTENT_KEY);
          this.$nextTick(function () {
            pageLoad(this);
          });
          return;
        }

        this.noticeListModel.list = state.list || [];
        this.noticeListModel.totalCount = state.totalCount || 0;
        this.noticeListModel.totalBoardCount = state.totalBoardCount || 0;
        this.noticeListModel.pager.pageNo = state.pager && state.pager.pageNo ? state.pager.pageNo : 1;
        this.noticeListModel.pager.rowSize = state.pager && state.pager.rowSize ? state.pager.rowSize : this.noticeListModel.pager.rowSize;

        this.noticeListModel.kword = state.kword || '';
        this.searchModel.searchKword = state.searchKword || '';

        const savedScrollY = state.scrollY || 0;
        this.isPolicyNoticeRestored = true;

        this.$nextTick(function () {
          // 복원 시에는 스크롤만 복원 (정책공지 페이지는 pageLoad에 별도 초기화 없음)
          setTimeout(function () {
            window.scrollTo(0, savedScrollY);
          }, 100);
        });

        sessionStorage.removeItem(POLICY_NOTICE_BACK_INTENT_KEY);

        console.log('Policy notice list state restored from session storage');
      } catch (e) {
        console.error('Failed to restore policy notice list state:', e);
        sessionStorage.removeItem(POLICY_NOTICE_STATE_KEY);
        sessionStorage.removeItem(POLICY_NOTICE_BACK_INTENT_KEY);
        this.$nextTick(function () {
          pageLoad(this);
        });
      }
    },

    // 공모전 목록 상태 저장
    savePolicyContestState: function () {
      try {
        const state = {
          contest: this.viewModel.contest,
          totalCount: this.viewModel.totalCount,
          pager: {
            pageNo: this.viewModel.pager.pageNo,
            rowSize: this.viewModel.pager.rowSize || 10
          },
          scrollY: window.scrollY,
          timestamp: Date.now()
        };
        sessionStorage.setItem(POLICY_CONTEST_STATE_KEY, JSON.stringify(state));
      } catch (e) {
        console.error('Failed to save policy contest list state:', e);
      }
    },

    // 공모전 목록 상태 복원
    restorePolicyContestState: function () {
      try {
        const savedState = sessionStorage.getItem(POLICY_CONTEST_STATE_KEY);
        if (!savedState) {
          this.$nextTick(function () {
            pageLoad(this);
          });
          return;
        }

        const state = JSON.parse(savedState);
        const TTL = 15 * 60 * 1000; // 15분

        if (Date.now() - state.timestamp > TTL) {
          sessionStorage.removeItem(POLICY_CONTEST_STATE_KEY);
          sessionStorage.removeItem(POLICY_CONTEST_BACK_INTENT_KEY);
          this.$nextTick(function () {
            pageLoad(this);
          });
          return;
        }

        this.viewModel.contest = state.contest || [];
        this.viewModel.totalCount = state.totalCount || 0;
        this.viewModel.pager.pageNo = state.pager && state.pager.pageNo ? state.pager.pageNo : 1;
        this.viewModel.pager.rowSize = state.pager && state.pager.rowSize ? state.pager.rowSize : 10;

        const savedScrollY = state.scrollY || 0;
        this.isPolicyContestRestored = true;

        this.$nextTick(function () {
          setTimeout(function () {
            window.scrollTo(0, savedScrollY);
          }, 100);
        });

        sessionStorage.removeItem(POLICY_CONTEST_BACK_INTENT_KEY);

        console.log('Policy contest list state restored from session storage');
      } catch (e) {
        console.error('Failed to restore policy contest list state:', e);
        sessionStorage.removeItem(POLICY_CONTEST_STATE_KEY);
        sessionStorage.removeItem(POLICY_CONTEST_BACK_INTENT_KEY);
        this.$nextTick(function () {
          pageLoad(this);
        });
      }
    },

    // 이벤트 목록 상태 저장
    savePolicyEventState: function () {
      try {
        const state = {
          list: this.viewModel.list,
          totalCount: this.viewModel.totalCount,
          pager: {
            pageNo: this.viewModel.pager.pageNo,
            rowSize: this.viewModel.pager.rowSize || 12
          },
          scrollY: window.scrollY,
          timestamp: Date.now()
        };
        sessionStorage.setItem(POLICY_EVENT_STATE_KEY, JSON.stringify(state));
      } catch (e) {
        console.error('Failed to save policy event list state:', e);
      }
    },

    // 이벤트 목록 상태 복원
    restorePolicyEventState: function () {
      try {
        const savedState = sessionStorage.getItem(POLICY_EVENT_STATE_KEY);
        if (!savedState) {
          this.$nextTick(function () {
            pageLoad(this);
          });
          return;
        }

        const state = JSON.parse(savedState);
        const TTL = 15 * 60 * 1000; // 15분

        if (Date.now() - state.timestamp > TTL) {
          sessionStorage.removeItem(POLICY_EVENT_STATE_KEY);
          sessionStorage.removeItem(POLICY_EVENT_BACK_INTENT_KEY);
          this.$nextTick(function () {
            pageLoad(this);
          });
          return;
        }

        this.viewModel.list = state.list || [];
        this.viewModel.totalCount = state.totalCount || 0;
        this.viewModel.pager.pageNo = state.pager && state.pager.pageNo ? state.pager.pageNo : 1;
        this.viewModel.pager.rowSize = state.pager && state.pager.rowSize ? state.pager.rowSize : 12;

        const savedScrollY = state.scrollY || 0;
        this.isPolicyEventRestored = true;

        this.$nextTick(function () {
          setTimeout(function () {
            window.scrollTo(0, savedScrollY);
          }, 100);
        });

        sessionStorage.removeItem(POLICY_EVENT_BACK_INTENT_KEY);

        console.log('Policy event list state restored from session storage');
      } catch (e) {
        console.error('Failed to restore policy event list state:', e);
        sessionStorage.removeItem(POLICY_EVENT_STATE_KEY);
        sessionStorage.removeItem(POLICY_EVENT_BACK_INTENT_KEY);
        this.$nextTick(function () {
          pageLoad(this);
        });
      }
    },

    fnGoEditSenateNotice: function() {
      let brdUidKey = $("#brdUidKey").val();
      if (brdUidKey) {
        location.href = "/customer/policy/senateSubmit?brdUidKey=" + brdUidKey;
      }
    },

    fnDelSenateNotice: function() {
      let vm = this;
      let brdUidKey = $("#brdUidKey").val();

      if (!brdUidKey) {
        swal({
          title: '오류',
          text: '삭제할 글을 찾을 수 없습니다.',
          icon: 'error',
          buttons: {
            confirm: {
              text: "확인",
              value: true,
              visible: true,
            },
          },
        });
        return;
      }

      swal({
        title: '삭제 확인',
        text: "정말로 이 글을 삭제하시겠습니까?\n삭제된 글은 복구할 수 없습니다.",
        icon: "warning",
        closeOnClickOutside: false,
        buttons: {
          confirm: {
            text: "삭제",
            value: true
          },
          cancel: {
            text: "취소",
            value: false
          }
        },
        dangerMode: true
      }).then(function(isConfirm) {
        if (isConfirm) {
          let param = {
            uidKey: brdUidKey
          };

          Axios.post("/api/notice/delete/board", param).then(function (response) {
            console.log(response);
            let _cnt = response.data.resultCnt;
            if (_cnt > 0) {
              swal({
                title: '삭제 완료',
                text: '글이 삭제되었습니다.',
                icon: 'success',
                buttons: {
                  confirm: {
                    text: "확인",
                    value: true,
                    visible: true,
                  },
                },
              }).then(result => {
                if (result) {
                  // 목록 페이지로 이동
                  location.href = "/customer/policy/senateNotice";
                }
              });
            } else {
              swal({
                title: '삭제 실패',
                text: '삭제에 실패하였습니다.',
                icon: 'error',
                buttons: {
                  confirm: {
                    text: "확인",
                    value: true,
                    visible: true,
                  },
                },
              });
            }
          }).catch(function (ex) {
            console.log(ex);
            swal({
              title: '오류 발생',
              text: '처리 중 오류가 발생했습니다.',
              icon: 'error',
              buttons: {
                confirm: {
                  text: "확인",
                  value: true,
                  visible: true,
                },
              },
            });
          });
        }
      });
    },

    fnGetPolicyEventList: function (pageNumber) {
      let vm = this;
      vm.viewModel.pager.rowSize = 12;
      vm.viewModel.pager.pageNo = pageNumber;

      if (pageNumber == 1) {
        vm.viewModel.list = [];
      }

      let brdCtg = $("#brdCtg").val();
      let brdSubCtg = $("#brdSubCtg").val();
      let param = {};

      param.brdCtg = brdCtg;
      param.brdSubCtg = brdSubCtg;
      param.pageNo = vm.viewModel.pager.pageNo;
      param.pageSize = vm.viewModel.pager.rowSize;

      // 복원 완료 상태라면 최초 한 번은 API 호출 스킵
      if (vm.isPolicyEventRestored) {
        vm.isPolicyEventRestored = false;
        return;
      }

      Axios.post("/customer/policy/event/list", param).then(function (response) {
        vm.viewModel.list = vm.viewModel.list.concat(response.data.eventList);

        if (response.data.totalCount == vm.viewModel.list.length) {
          vm.viewModel.showMore = false;
        } else {
          vm.viewModel.showMore = true;
        }

        // 상태 저장
        vm.savePolicyEventState();
      }).catch(function (ex) {
        console.log(ex);
      });

    },

    fnGetPolicyEventDetail: function () {
      let vm = this;
      let param = {
        uidKey: $("#uidKey").val()
      };

      // 상세 페이지 진입 시 backIntent 설정
      sessionStorage.setItem(POLICY_EVENT_BACK_INTENT_KEY, 'true');

      Axios.post("/customer/policy/event/detail", param).then(function (response) {
        vm.mentoGroupModel.eventVO = response.data.event;
        document.title = response.data.event.title;

        vm.fnGetBoardDetail();

      }).catch(function (ex) {
        console.log(ex);
      });
    },
    fnGetBoardDetail() {
      let vm = this;
      let param = {
        uidKey: $("#uidKey").val(),
        userKey: $("#usrKey").val()
      };
      Axios.post("/api/pare/board/detail", param).then(function (response) {
        vm.replyModel.userKey = $("#usrKey").val();
        vm.replyModel.replyList = (response.data.pareBcomList == null) ? [] : response.data.pareBcomList;
        vm.replyModel.rereplyList = (response.data.pareReBcomList == null) ? [] : response.data.pareReBcomList;


      }).catch(function (ex) {
        console.log(ex);
      });
    },

    OnClickPareReviewReplyDelete: function (reply_uid) {
      let vm = this;

      let param = {
        buid: $("#uidKey").val(),
        uidKey: reply_uid
      };

      swal({
        text: "해당 댓글을 삭제하시겠습니까?",
        closeOnClickOutside: false,
        buttons: {
          confirm: {
            text: "확인",
            value: true
          },
          cancle: {
            text: "취소",
            value: false
          }
        },
        dangerMode: false
      }).then(function (isConfirm) {
        if (isConfirm) {
          Axios.post("/api/pare/contents/reply/delete", param).then(function (response) {
            let result = response.data.result;
            if (result == 1) {

              vm.fnSwalSuccess('삭제되었습니다.', vm.fnGetBoardDetail());

            } else {
              vm.fnSwalAlert('댓글삭제에 실패하였습니다.');
              return false;
            }
          }).catch(function (ex) {
            console.log(ex);
            vm.fnSwalAlert('댓글삭제에 실패하였습니다.');
            return false;
          });
        } else {
          return false;
        }
      });

    },
    onClickEventReplyModity: function (item) {
      let vm = this;
      vm.replyModel.modifyTarget = item.replyUid;
      vm.replyModel.modifyContents = item.content;
      vm.fpt = ''
    },
    onClickEventRemodirfySubmit: function (reply_uid) {
      let vm = this;
      let param = {};

      param = {
        buid: $("#uidKey").val(),
        uidKey: reply_uid,
        userKey: vm.replyModel.userKey,
        content: vm.replyModel.modifyContents,
        starCnt: 0
      };

      Axios.post("/api/pare/contents/reply/modify", param).then(function (response) {
        let result = response.data.result;
        if (result > 0) {
          vm.fnSwalSuccess('정상적으로 수정되었습니다.', vm.onClickPareReviewRemodirfyCancle());
        } else if (result == -999) {
          swal({
            title: '수정 실패',
            text: '수정에 실패하였습니다(개인정보 또는 비속어 포함)',
            // icon: vm.fnOnLoadSwalImageData('error'),
            buttons: {
              cancel: {
                text: "취소",
                value: false,
                visible: false
              },
              confirm: {
                text: "확인",
                value: true,
                visible: true
              },
            },
            dangerMode: false
          }).then(result => {
            if (result) {
              return false;
            }
          });
        } else {
          vm.fnSwalAlert('댓글수정에 실패하였습니다.');
          return false;
        }
      }).catch(function (ex) {
        console.log(ex);
        vm.fnSwalAlert('댓글수정에 실패하였습니다.');
        return false;
      });
    },
    onClickPareReviewRemodirfyCancle: function () {
      let vm = this;
      vm.replyModel.modifyContents = '';
      vm.replyModel.modifyTarget = '';
      vm.fnGetBoardDetail();
    },
    fnGetContestList: function (pageNumber) {
      let vm = this;
      vm.viewModel.pager.pageNo = pageNumber;

      if (pageNumber == 1) {
        vm.viewModel.list = [];
      }

      let brdCtg = $("#brdCtg").val();
      let brdSubCtg = $("#brdSubCtg").val();
      let param = {
        brdCtg: brdCtg,
        brdSubCtg: brdSubCtg,
        pageNo: vm.viewModel.pager.pageNo,
        pageSize: 10
      };

      // 복원 완료 상태라면 최초 한 번은 API 호출 스킵
      if (vm.isPolicyContestRestored) {
        vm.isPolicyContestRestored = false;
        return;
      }

      Axios.post("/customer/policy/contest/list", param).then(function (response) {

        vm.viewModel.contest = vm.viewModel.contest.concat(response.data.policyContestList);

        if (response.data.totalCount == vm.viewModel.contest.length) {
          vm.viewModel.showMore = false;
        } else {
          vm.viewModel.showMore = true;
        }
        vm.viewModel.totalCount = response.data.totalCount;

        // 상태 저장
        vm.savePolicyContestState();
      }).catch(function (ex) {
        console.log(ex);
      });
    },

    fnGetContestDetail: function() {
      let vm = this;
      let param = {
        uidKey: $("#uidKey").val()
      };

      // 상세 페이지 진입 시 backIntent 설정
      sessionStorage.setItem(POLICY_CONTEST_BACK_INTENT_KEY, 'true');

      Axios.post("/customer/policy/contest/detail", param).then(function (response) {
        vm.viewModel.detail = response.data.policyContest;
        vm.viewModel.fileEtcList = response.data.fileEtcList;

        vm.viewModel.fileEtcList.forEach(function (file) {
          file.fileUrl = "/doc/" + file.file_new_name.substr(0, 8) + "/" + file.file_new_name;
        });

      }).catch(function (ex) {
        console.log(ex);
      });

    }
    , validationReply() {
      let vm = this;
      let userKey = $("#userKey").val();
      let replyName = vm.replyName == "" ? false : true;
      let replyPassword = vm.replyPassword == "" ? false : true;
      let content = vm.replyContents == "" ? false : true;

      if (userKey == null || userKey == "") {
        if (!replyName) {
          vm.fnSwalAlert('게스트 이름이 입력되지 않았습니다.');
          return false;
        } else if (!replyPassword) {
          vm.fnSwalAlert('게스트 비밀번호가 입력되지 않았습니다.');
          return false;
        }
      }

      if (!content) {
        vm.fnSwalAlert('내용이 입력되지 않았습니다.');
        return false;
      }
      if (userKey == null || userKey == "") {
        if (replyName && replyPassword && content) {
          return true;
        }
      } else {
        if (content) {
          return true;
        }
      }
    }
    , fnSwalAlert(_text) {
      swal({
        text: _text,
        closeOnClickOutside: false,
        // icon       : this.fnOnLoadSwalImageData('warning'),
        buttons: {
          confirm: {
            text: "확인",
            value: true
          },
          cancel: {
            text: "취소",
            value: false,
            visible: false
          }
        }
      });
    }
    , fnSwalSuccess(_text, successFunction) {
      let vm = this;

      swal({
        text: _text,
        closeOnClickOutside: false,
        // icon : vm.fnOnLoadSwalImageData("success"),
        buttons: {
          confirm: {
            text: "확인",
            value: true,
            visible: true
          },
          cancel: {
            text: "취소",
            value: false,
            visible: false
          }
        }
      }).then(result => {
        if (result) {
          if (successFunction != null) {
            successFunction();
          }
        }
      });
    },

    onClickEventReplySubmit() {
      let vm = this;
      vm.isReplyOn = true;
      vm.replyModel.userKey = $("#usrKey").val();

      let param = {
        buid: vm.mentoGroupModel.eventVO.uidKey,
        starCnt: vm.replyModel.replyStarCnt,
        userKey: vm.replyModel.userKey,
        content: vm.replyModel.replyContents
      };

      if (vm.validationReply()) {
        Axios.post("/api/pare/contents/reply/write", param).then(function (response) {
          let result = response.data.result;
          if (result == 1) {
            vm.fnSwalSuccess('정상적으로 등록되었습니다.', vm.onClickEventReviewReplyCancle());
          } else if (result == -999) {
            swal({
              title: '등록 실패',
              text: '등록에 실패하였습니다(개인정보 또는 비속어 포함)',
              // icon: vm.fnOnLoadSwalImageData('error'),
              buttons: {
                cancel: {
                  text: "취소",
                  value: false,
                  visible: false
                },
                confirm: {
                  text: "확인",
                  value: true,
                  visible: true
                },
              },
              dangerMode: false
            }).then(result => {
              if (result) {
                return false;
              }
            });
          } else {
            vm.fnSwalAlert('댓글등록에 실패하였습니다.');
            return false;
          }
        }).catch(function (ex) {
          console.log(ex);
          vm.fnSwalAlert('댓글등록에 실패하였습니다.');
          return false;
        });
      }

    },
    onClickEventReviewReplyCancle() {
      let vm = this;
      vm.isReplyOn = false;
      vm.isReReplyOn = false;
      vm.replyModel.replyContents = '';
      vm.fnGetBoardDetail();
    },
    fnVoiceSuggestTab: function (tabIdx) {
      let vm = this;
      if (tabIdx == 1) { //정책제안
        vm.viewModel.isVoiceTab = true;
        vm.viewModel.isExellentTab = false;
        vm.viewModel.isLiveTab = false;
      } else if (tabIdx == 2) { //우수정책제안
        vm.viewModel.isVoiceTab = false;
        vm.viewModel.isExellentTab = true;
        vm.viewModel.isLiveTab = false;
        vm.fnGetVoiceSuggestList('likeCnt');
      } else if (tabIdx == 3) { //Live 정책제안
        vm.viewModel.isVoiceTab = false;
        vm.viewModel.isExellentTab = false;
        vm.viewModel.isLiveTab = true;
      }
    },

    fnGetVoiceSuggestList: function (tab, pageNumber, searchOrder, brdSubCtg) {
      let vm = this;
      vm.fnHideLikeList();
      vm.viewModel.pager.pageNo = pageNumber ? pageNumber : 1;
      vm.viewModel.voiceTab = !tab ? vm.viewModel.voiceTab : tab;
      vm.suggLi = searchOrder;

      if(vm.viewModel.pager.pageNo == 1){
        vm.viewModel.proposalList = [];
      }

      if($("#paramCate").val() != undefined && (brdSubCtg == null)){
        vm.searchModel.brdSubCtg = $("#paramCate").val() != undefined ? $("#paramCate").val() : '';
      }else{
        vm.searchModel.brdSubCtg = brdSubCtg;
      }

      let param = {};
      param.approve = "approve";
      param.tab = vm.viewModel.voiceTab;
      param.brdSubCtg = vm.searchModel.brdSubCtg;
      param.searchKeyword = vm.searchModel.searchKword;
      param.searchYear = vm.selectYearModel.yearValue;
      param.pageNo = vm.viewModel.pager.pageNo;
      param.pageSize = vm.viewModel.pager.rowSize;
      param.searchOrder = searchOrder;

      console.log(param);

      Axios.post("/customer/voice/selectVoiceSuggestList", {voiceVo: param}).then(function (response) {
        if (response.data.list.length > 0) {
          response.data.list.forEach(function (item) {
            item.content1 = vm.fnOnLoadKakaoContent(item.content1);
            item.content1 = item.content1.replace(/<(\/ol|ol|\/li|li)([^>]*)>/gi, "");
          });
        }

        vm.viewModel.hundredCount = response.data.hundredCount;
        vm.viewModel.totalCount = response.data.totalCount;
        vm.viewModel.proposalList = vm.viewModel.proposalList.concat(response.data.list);
        vm.fnSetPager(vm.viewModel.totalCount, "selectVoiceSuggestList");

        if(response.data.totalCount === vm.viewModel.proposalList.length) {
          vm.viewModel.showMore = false;
        } else {
          vm.viewModel.showMore = true;
        }

        // 상태 저장
        vm.saveVoiceSuggestState();
      }).catch(function (ex) {
        console.log(ex);
      });
    },

    fnGoVoiceDetail: function (uid) { //시민청원 상세보기
      let pageName = $("#pageName").val();
      let vm = this;

      if (pageName == 'voiceMain') {
        let order = vm.viewModel.voiceTab;

        let pageNum = vm.viewModel.pager.pageNo;

        //sessionStorage.setItem("URL", "/customer/voice?order=" + order + "&pageNum=" + pageNum);
      } else if (pageName == "voiceSuggestMain") {
        let tabIdx = 0;
        let subTab = "";
        let pageNum = vm.viewModel.pager.pageNo;

        if (vm.viewModel.isVoiceTab) {
          tabIdx = 1;
          subTab = vm.viewModel.voiceTab;
        } else if (vm.viewModel.isExellentTab) {
          tabIdx = 2;
        }

        let cate = vm.searchModel.brdSubCtg;
        let searchword = vm.searchModel.searchKeyword;
        let year = (vm.selectYearModel.yearValue == null
          || vm.selectYearModel.yearValue == undefined
          || vm.selectYearModel.yearValue == "") ? "" : vm.selectYearModel.yearValue;

        /*sessionStorage.setItem("URL", "/customer/voice/voiceSuggestMain?cate=" + cate
          + "&tabIdx=" + tabIdx
          + "&subTab=" + subTab
          + "&year=" + year
          + "&searchword=" + searchword
          + "&pageNum=" + pageNum);*/
      }

      try {
        if (typeof this.saveVoiceSuggestState === 'function') {
          this.saveVoiceSuggestState();
        }
      } catch (e) {
        console.error('Failed to save voice suggest state before detail:', e);
      }
      sessionStorage.setItem(VOICE_SUGGEST_BACK_INTENT_KEY, 'true');

      location.href = '/customer/policy/proposalDetail?brdUidKey=' + uid;
    },

    fnUptVoiceSuggest: function () {
      let vm = this;

      if ($("#usrKey").val() == null || $("#usrKey").val() == "") {
        swal({
          text : "로그인한 회원만 가능합니다.\n로그인하시겠습니까?",
          closeOnClickOutside : false,
          buttons : {
            confirm : {
              text : "확인",
              value : true,
              visible : true
            },
            cancel : {
              text : "취소",
              value : false,
              visible : true
            }
          }
        }).then(result => {
          if(result){
            location.href = "/youthnavi/signup/login?returnURI=" + encodeURIComponent(window.location.pathname + window.location.search);
          }
        });
        return false;
      }

      if (vm.selectVoiceModelType == '') {
        swal("카테고리를 입력해주세요.").then(function(){
          $('#cateCodeList').focus();
        });
        return false;
      } else if (validation.isEmpty(vm.insertVoice.title)) {
        swal("제목을 입력해주세요.").then(function(){
          $('#insertVoiceTitle').focus();
        });
        return false;
      } else if (!validation.isLength(vm.insertVoice.title, 0, 200)) {
        swal("제목이 너무 깁니다.").then(function(){
          $('#insertVoiceTitle').focus();
        });
        return false;
      } else if (validation.isEmpty(vm.insertVoice.content2)) {
        swal("배경 및 필요성을 입력해주세요.").then(function(){
          $('#insertVoiceContent2').focus();
        });
        return false;
      } else if (validation.isEmpty(vm.insertVoice.content1)) {
        swal("내용을 입력해주세요.").then(function(){
          $('#insertVoiceContent1').focus();
        });
        return false;
      } else if (validation.isEmpty(vm.insertVoice.content3)) {
        swal("기대효과를 입력해주세요.").then(function(){
          $('#insertVoiceContent3').focus();
        });
        return false;
      }

      let param = {};
      param.brdUidKey = $("#paramUid").val();
      param.usrKey = $("#usrKey").val();
      param.usrId = $("#usrId").val();
      param.fileKey = $("#fileKey").val();
      param.brdSubCtg = vm.selectVoiceModelType.cateCd;
      param.title = vm.insertVoice.title;
      param.content1 = vm.insertVoice.content1;
      param.content2 = vm.insertVoice.content2;
      param.content3 = vm.insertVoice.content3;
      param.keyword = vm.insertVoice.keyword;
      param.link = vm.insertVoice.link;

      vm.fnOnSwalAlert("정책제안", "수정하시겠습니까?",
        function () {
          Axios.post("/customer/voice/updateVoiceSuggest", {voiceVo: param}).then(function (response) {
            if (response.data.succCnt > 0) {
              swal({
                title: '수정 완료',
                text: '수정이 완료되었습니다.',
                // icon: vm.fnOnLoadSwalImageData('success'),
                buttons: {
                  confirm: {
                    text: "확인",
                    value: true,
                    visible: true,
                  },
                },
                dangerMode: false
              }).then(result => {
                if (result) {
                  window.history.back();
                }
              });
            } else if (response.data.succCnt == -999) {
              swal({
                title: '등록 실패',
                text: '등록에 실패하였습니다(개인정보 또는 비속어 포함)',
                // icon: vm.fnOnLoadSwalImageData('error'),
                buttons: {
                  cancel: {
                    text: "취소",
                    value: false,
                    visible: false,
                  },
                  confirm: {
                    text: "확인",
                    value: true,
                    visible: true,
                  },
                },
                dangerMode: false
              }).then(result => {
                if (result) {
                  return false;
                }
              });
            }
          }).catch(function (ex) {
            console.log(ex);
          });
        }
      );
    },

    fnUptSenateSuggest: function () {
      let vm = this;

      if ($("#usrKey").val() == null || $("#usrKey").val() == "") {
        swal("로그인이 필요합니다.").then(function(){
          location.href='/customer/account/login';
        });
        return false;
      }

      if (validation.isEmpty(vm.insertSenate.title)) {
        swal("제목을 입력해주세요.").then(function(){
          $('#insertSenateTitle').focus();
        });
        return false;
      } else if (!validation.isLength(vm.insertSenate.title, 0, 200)) {
        swal("제목이 너무 깁니다.").then(function(){
          $('#insertSenateTitle').focus();
        });
        return false;
      } else if (validation.isEmpty(vm.insertSenate.content1)) {
        swal("내용을 입력해주세요.").then(function(){
          $("html, body").animate({scrollTop: $("#insertSenateContent1").offset().top-200}, 100);
        });
        return false;
      }

      // 새로운 API 형식에 맞게 데이터 구성
      let detailObj = {
        uidKey: $("#brdUidKey").val(),
        category: 'BRDNVYTHNV06000',
        subCategory: 'BRDNVSUBNV00100',
        title: vm.insertSenate.title,
        content: vm.insertSenate.content1,
        delYn: 'N',
        fileKey: $("#fileKey").val(),
        usrKey: $("#usrKey").val(),
        usrId: $("#usrId").val(),
        keyword: vm.insertSenate.keyword || ''
      };

      let param = {
        paramText: JSON.stringify(detailObj)
      };

      swal({
        text : "정책제안을 수정하시겠습니까?",
        icon : "info",
        closeOnClickOutside : false,
        buttons : {
          confirm : {
            text : "확인",
            value : true
          }
          ,cancle : {
            text : "취소",
            value : false
          }
        },
        dangerMode: false
      }).then(function(isConfirm) {
        if (isConfirm) {
          // insertSenate와 동일한 형태의 updateSenate API 사용
          Axios.post("/customer/policy/updateSenate", param).then(function (response) {
            console.log(response);
            let _cnt = response.data.resultCnt;
            if (_cnt > 0) {
              swal({
                title: '수정 완료',
                text: '수정이 완료되었습니다.',
                buttons: {
                  confirm: {
                    text: "확인",
                    value: true,
                    visible: true,
                  },
                },
                dangerMode: false
              }).then(result => {
                if (result) {
                  window.history.back();
                }
              });
            } else {
              swal({
                title: '수정 실패',
                text: '수정에 실패하였습니다.',
                buttons: {
                  confirm: {
                    text: "확인",
                    value: true,
                    visible: true,
                  },
                },
                dangerMode: false
              });
            }
          }).catch(function (ex) {
            console.log(ex);
            swal({
              title: '오류 발생',
              text: '처리 중 오류가 발생했습니다.',
              buttons: {
                confirm: {
                  text: "확인",
                  value: true,
                  visible: true,
                },
              },
              dangerMode: false
            });
          });
        } else {
          return false;
        }
      });
    },

    fnGetCodeList: function (cdGrp) {
      let vm = this;
      let param = {voiceVo: {}};
      Axios.post("/customer/voice/selectCodeList", param).then(function (response) {
        response.data.list.forEach(function (item) {
          switch (item.cateCd) {
            case 'VOICECATENV00700':
              item.cateClass = 'art';
              break;
            case 'VOICECATENV01300':
              item.cateClass = 'mind';
              break;
            case 'VOICECATENV00200':
              item.cateClass = 'edu';
              break;
            case 'VOICECATENV01400':
              item.cateClass = 'safe';
              break;
            case 'VOICECATENV00300':
              item.cateClass = 'job';
              break;
            case 'VOICECATENV00600':
              item.cateClass = 'place';
              break;
            case 'VOICECATENV01200':
              item.cateClass = 'etc';
              break;
            default:
              item.cateClass = 'etc';
          }
        });
        vm.viewModel.codeList = response.data.list;
      }).catch(function (ex) {
        console.log(ex);
      });
    },

    fnGetYearList: function () {
      let vm = this;
      let today = new Date();
      let year = today.getFullYear();
      for (let i = 0; i < 5; i++) {
        let yearObj = {yearValue: (year - i), yearName: (year - i) + "년도"};
        vm.viewModel.yearList.push(yearObj);
      }
    },
    fnGetReportCodeList: function () {
      let vm = this;
      Axios.post("/customer/voice/selectReportCodeList", {voiceVo: {}}).then(function (response) {
        vm.viewModel.reportCodeList = response.data.list;
      }).catch(function (ex) {
        console.log(ex);
      });
    },
    fnGetVoiceReportList: function () {
      let vm = this;
      let param = {};
      // policy detail 페이지는 brdUidKey를 사용하므로 fallback 추가
      param.brdUidKey = $("#paramUid").val() || $("#brdUidKey").val();
      param.usrKey = $("#usrKey").val();

      Axios.post("/customer/voice/selectVoiceReportList", {voiceVo: param}).then(function (response) {
        vm.viewModel.reportList = (response.data && response.data.list) ? response.data.list : [];

        if (vm.viewModel.reportList != null) {
          vm.viewModel.reportList.forEach(function (report) {
            if (report.rcmmCate == "RCMNVYTHNV00100" && report.likeYn == "Y") { //좋아요
              vm.viewModel.isLike = true;
            }
          });
        }
      }).catch(function (ex) {
        console.log(ex);
      });
    },
    fnSetVoiceSuggest: function () {
      let vm = this;

      if ($("#usrKey").val() == null || $("#usrKey").val() == "") {
        swal({
          text : "로그인한 회원만 가능합니다.\n로그인하시겠습니까?",
          closeOnClickOutside : false,
          buttons : {
            confirm : {
              text : "확인",
              value : true,
              visible : true
            },
            cancel : {
              text : "취소",
              value : false,
              visible : true
            }
          }
        }).then(result => {
          if(result){
            location.href = "/youthnavi/signup/login?returnURI=" + encodeURIComponent(window.location.pathname + window.location.search);
          }
        });
        return false;
      }

      if (vm.selectVoiceModelType == '') {
        console.log('test1');
        console.log('test2');
        swal("카테고리를 선택해주세요.").then(function(){
          $('#cateCodeList').focus();
        });
        return false;
      } else if (validation.isEmpty(vm.insertVoice.title)) {
        swal("제목을 입력해주세요.").then(function(){
          $('#insertVoiceTitle').focus();
        });
        return false;
      } else if (!validation.isLength(vm.insertVoice.title, 0, 200)) {
        swal("제목이 너무 깁니다.").then(function(){
          $('#insertVoiceTitle').focus();
        });
        return false;
      } else if (validation.isEmpty(vm.insertVoice.content2)) {
        swal("배경 및 필요성을 입력해주세요.").then(function(){
          $('#insertVoiceContent2').focus();
        });
        return false;
      } else if (validation.isEmpty(vm.insertVoice.content1)) {
        swal("내용을 입력해주세요.").then(function(){
          $('#insertVoiceContent1').focus();
        });
        return false;
      } else if (validation.isEmpty(vm.insertVoice.content3)) {
        swal("기대효과를 입력해주세요.").then(function(){
          $('#insertVoiceContent3').focus();
        });
        return false;
      } else if (!vm.viewModel.admit1 || !vm.viewModel.admit2) {
        swal("약관에 동의해주세요.");
        return false;
      }

      let param = {};
      param.usrKey = $("#usrKey").val();
      param.usrId = $("#usrId").val();
      param.fileKey = $("#fileKey").val();
      param.brdSubCtg = vm.selectVoiceModelType.cateCd;
      param.title = vm.insertVoice.title;
      param.content1 = vm.insertVoice.content1;
      param.content2 = vm.insertVoice.content2;
      param.content3 = vm.insertVoice.content3;
      param.keyword = vm.insertVoice.keyword;
      param.link = vm.insertVoice.link;
      param.suggest = 'suggest';

      param.approve = "approve";

      swal({
        text : "정책제안을 등록하시겠습니까?",
        icon : "info",
        closeOnClickOutside : false,
        buttons : {
          confirm : {
            text : "확인",
            value : true
          }
          ,cancle : {
            text : "취소",
            value : false
          }
        },
        dangerMode: false
      }).then(function(isConfirm) {
        if (isConfirm) {
          Axios.post("/customer/voice/insertVoiceSuggest", {voiceVo: param}).then(function (response) {
            if (response.data.succCnt > 0) {
              swal({
                title: '등록 완료',
                text: '정상 등록되었습니다.',
                // icon: vm.fnOnLoadSwalImageData('success'),
                buttons: {
                  confirm: {
                    text: "확인",
                    value: true,
                    visible: true,
                  },
                },
                dangerMode: false
              }).then(result => {
                if (result) {
                  window.history.back();
                }
              });
            } else if (response.data.succCnt == -999) {
              swal({
                title: '등록 실패',
                text: '등록에 실패하였습니다(개인정보 또는 비속어 포함)',
                // icon: vm.fnOnLoadSwalImageData('error'),
                buttons: {
                  cancel: {
                    text: "취소",
                    value: false,
                    visible: false,
                  },
                  confirm: {
                    text: "확인",
                    value: true,
                    visible: true,
                  },
                },
                dangerMode: false
              }).then(result => {
                if (result) {
                  return false;
                }
              });
            }
          }).catch(function (ex) {
            console.log(ex);
          });
        }else{
          return false;
        }
      });

    },
    fnGetVoiceBoardDetail: function (updateFlag) {
      let vm = this;
      let param = {};
      param.brdUidKey = $("#brdUidKey").val();
      param.updateFlag = updateFlag ? updateFlag : null;

      Axios.post("/customer/voice/selectVoiceBoardDetail", {voiceVo: param}).then(function (response) {
        vm.viewModel.detail = response.data.voiceVo;


      }).catch(function (ex) {
        console.log(ex);
      });
    },

    // 좋아요/신고 처리
    fnSetReport1: function () {
      // 일부 JSP에서 별도의 함수명을 호출할 수 있어 wrapper 제공
      this.fnSetReport('report');
    },
    fnSetReport: function (kind) {
      let vm = this;

      let url = "/customer/voice/insertRecommend";

      if (kind === 'report') {
        if (!vm.insertVoiceReport.reportValue) {
          swal("신고사유를 선택해주세요.");
          return false;
        } else if (vm.insertVoiceReport.reportValue === 'RPTNVYTHNV00400' && (!vm.insertVoiceReport.reportEtcValue || vm.insertVoiceReport.reportEtcValue.trim().length === 0)) {
          swal("기타사유를 입력해 주세요");
          return false;
        }
      } else if (kind === 'like') {
        if ($("#usrKey").val() == null || $("#usrKey").val() == "") {
          swal({
            text : "좋아요는 로그인한 회원만 가능합니다.\n로그인하시겠습니까?",
            closeOnClickOutside : false,
            buttons : {
              confirm : { text : "확인", value : true, visible : true },
              cancel  : { text : "취소", value : false, visible : true }
            }
          }).then(result => {
            if(result){
              location.href = "/youthnavi/signup/login?returnURI=" + encodeURIComponent(window.location.pathname + window.location.search);
            }
          });
          return false;
        }

        if (vm.viewModel.detail && vm.viewModel.detail.usrKey && vm.viewModel.detail.usrKey == $("#usrKey").val()) {
          swal("자신이 올린 글은 공감할 수 없습니다.");
          vm.viewModel.isLike = false;
          return false;
        }

        if (Array.isArray(vm.viewModel.reportList) && vm.viewModel.reportList.length > 0) {
          vm.viewModel.reportList.forEach(function (report) {
            if (report.rcmmCate == "RCMNVYTHNV00100") { //좋아요
              url = "/customer/voice/updateVoiceLike";
            }
          });
        }
      }

      let param = {};
      param.brdUidKey = $("#brdUidKey").val() || $("#paramUid").val();
      param.usrKey = $("#usrKey").val();
      param.usrId = $("#usrId").val();
      if (kind === 'like') {
        param.rcmmCate = "RCMNVYTHNV00100"; // 추천
        param.likeYn = vm.viewModel.isLike ? 'N' : 'Y';
      } else if (kind === 'report') {
        param.rcmmCate = "RCMNVYTHNV00200"; // 신고
        param.reportValue = vm.insertVoiceReport.reportValue;
        if (vm.insertVoiceReport.reportValue === "RPTNVYTHNV00400") {
          param.reportEtcValue = vm.insertVoiceReport.reportEtcValue;
        }
      }

      Axios.post(url, {voiceVo: param}).then(function (response) {
        if (kind === 'like') {
          vm.viewModel.isLike = !vm.viewModel.isLike;
          // 카운트 증감 처리 (상세에 likeCnt 있으면)
          if (vm.viewModel.detail && vm.viewModel.detail.likeCnt != null) {
            let currentCnt = parseInt(vm.viewModel.detail.likeCnt) || 0;
            if (vm.viewModel.isLike) {
              vm.viewModel.detail.likeCnt = currentCnt + 1;
            } else {
              vm.viewModel.detail.likeCnt = Math.max(0, currentCnt - 1);
            }
          }
          // 리스트 보정
          if (!Array.isArray(vm.viewModel.reportList)) vm.viewModel.reportList = [];
          let hasLike = vm.viewModel.reportList.some(r => r.rcmmCate === 'RCMNVYTHNV00100');
          if (!hasLike) vm.viewModel.reportList.push({ rcmmCate: 'RCMNVYTHNV00100', likeYn: vm.viewModel.isLike ? 'Y' : 'N' });
        } else if (kind === 'report') {
          if (response.data && response.data.succCnt > 0) {
            swal("등록되었습니다.").then(() => { window.location.reload(); });
          } else {
            swal("처리에 실패했습니다.");
          }
        }
      }).catch(function (ex) {
        console.log(ex);
      });
    },
    fnShowReportWrite: function () {
      let vm = this;
      if ($("#usrKey").val() == null || $("#usrKey").val() == "") {
        swal({
          text : "신고하기는 로그인한 회원만 가능합니다.\n로그인하시겠습니까?",
          closeOnClickOutside : false,
          buttons : {
            confirm : { text : "확인", value : true, visible : true },
            cancel  : { text : "취소", value : false, visible : true }
          }
        }).then(result => {
          if(result){
            location.href = "/youthnavi/signup/login?returnURI=" + encodeURIComponent(window.location.pathname + window.location.search);
          }
        });
        return false;
      }

      let reportFlag = false;
      if (Array.isArray(vm.viewModel.reportList) && vm.viewModel.reportList.length > 0) {
        vm.viewModel.reportList.forEach(function (report) {
          if (report.rcmmCate == "RCMNVYTHNV00200") { //신고
            reportFlag = true;
          }
        });
      }

      if (reportFlag) {
        swal("접수된 신고 이력이 있습니다.");
        return false;
      } else {
        vm.viewModel.isReport = !vm.viewModel.isReport;
      }
    },

    fnGetNoticeBoardDetailForEdit: function (updateFlag) {
      let vm = this;
      let param = {
        uidKey: $("#brdUidKey").val()
      };

      Axios.post("/customer/policy/notice/detail", param).then(function (response) {
        vm.viewModel.detail = response.data.detail;

        // 수정모드일 때 입력 필드에 기존 데이터 설정
        if (updateFlag === "update" && response.data.detail) {
          vm.insertSenate.title = response.data.detail.title;
          vm.insertSenate.content1 = response.data.detail.contentFirst || response.data.detail.content1;
          vm.insertSenate.keyword = response.data.detail.keyword || '';
        }

      }).catch(function (ex) {
        console.log(ex);
      });
    },
    fnGetVoiceReplyList: function (pageNumber) {
      let vm = this;
      //vm.viewModel.pager.pageNo = pageNumber ? pageNumber : 1;

      let param = {};
      param.brdUidKey = $("#paramUid").val();
      //param.pageNo    = vm.viewModel.pager.pageNo;
      //param.pageSize  = vm.viewModel.pager.rowSize;

      Axios.post("/customer/voice/selectVoiceReplyList", {voiceVo: param}).then(function (response) {
        vm.viewModel.totalReplyCount = response.data.depthZeroList.length;
        vm.viewModel.replyDepthZero = response.data.depthZeroList;
        vm.viewModel.replyDepthOne = response.data.depthOneList;
        //vm.fnSetPager(vm.viewModel.totalCount, "selectReplyList",vm.viewModel.pager);
        // vm.viewModel.totalCount = response.data.totalCount;
        // vm.viewModel.replyList = response.data.list;
        // vm.viewModel.replyList.forEach(function(reply){
        //     if(reply.fileNewName != null){
        //         reply.fileNewName = "/img/" + reply.fileNewName.substr(0,8) + "/" + reply.fileNewName;
        //     }
        // });
      }).catch(function (ex) {
        console.log(ex);
      });
    },

    fnSetContestSuggest: function () {
      let vm = this;

      if ($("#usrKey").val() == null || $("#usrKey").val() == "") {
        swal({
          text : "로그인한 회원만 가능합니다.\n로그인하시겠습니까?",
          closeOnClickOutside : false,
          buttons : {
            confirm : {
              text : "확인",
              value : true,
              visible : true
            },
            cancel : {
              text : "취소",
              value : false,
              visible : true
            }
          }
        }).then(result => {
          if(result){
            location.href = "/youthnavi/signup/login?returnURI=" + encodeURIComponent(window.location.pathname + window.location.search);
          }
        });
        return false;
      }

      if (vm.selectVoiceModelType == '') {
        swal("카테고리를 선택해주세요.").then(function(){
          $('#cateCodeList').focus();
        });
        return false;
      } else if (validation.isEmpty(vm.insertVoice.title)) {
        swal("제목을 입력해주세요.").then(function(){
          $('#insertVoiceTitle').focus();
        });
        return false;
      } else if (!validation.isLength(vm.insertVoice.title, 0, 200)) {
        swal("제목이 너무 깁니다.").then(function(){
          $('#insertVoiceTitle').focus();
        });
        return false;
      } else if (validation.isEmpty(vm.insertVoice.keyword)) {
        swal("키워드를 입력해주세요.").then(function(){
          $('#insertVoiceKeyword').focus();
        });
        return false;
      } else if (validation.isEmpty(vm.insertVoice.content2)) {
        swal("배경 및 필요성을 입력해주세요.").then(function(){
          $('#insertVoiceContent2').focus();
        });
        return false;
      }else if (validation.isEmpty(vm.insertVoice.content1)) {
        swal("내용을 입력해주세요.").then(function(){
          $('#insertVoiceContent1').focus();
        });
        return false;
      } else if (validation.isEmpty(vm.insertVoice.content3)) {
        swal("기대효과를 입력해주세요.").then(function(){
          $('#insertVoiceContent3').focus();
        });
        return false;
      } else if (!vm.viewModel.admit1 || !vm.viewModel.admit2) {
        swal("약관에 동의해주세요.");
        return false;
      }

      let param = {};
      param.brdUidKey = $("#brdUidKey").val();
      param.usrId = $("#usrId").val();
      param.fileKey = $("#fileKey").val();
      param.category = vm.selectVoiceModelType.cateCd;
      param.title = vm.insertVoice.title;
      param.content1 = vm.insertVoice.content1;
      param.content2 = vm.insertVoice.content2;
      param.content3 = vm.insertVoice.content3;
      param.keyword = vm.insertVoice.keyword;
      param.link = vm.insertVoice.link;

      swal({
        text : "공모전을 등록하시겠습니까?",
        icon : "info",
        closeOnClickOutside : false,
        buttons : {
          confirm : {
            text : "확인",
            value : true
          }
          ,cancle : {
            text : "취소",
            value : false
          }
        },
        dangerMode: false
      }).then(function(isConfirm) {
        if (isConfirm) {
          let _param = { paramText : JSON.stringify(param)};
          Axios.post("/customer/policy/insertContest", _param).then(function (response)
          {
            if (response.data.resultCnt > 0) {
              swal({
                title: '등록 완료',
                text: '정상 등록되었습니다.',
                // icon: vm.fnOnLoadSwalImageData('success'),
                buttons: {
                  confirm: {
                    text: "확인",
                    value: true,
                    visible: true,
                  },
                },
                dangerMode: false
              }).then(result => {
                if (result) {
                  window.history.back();
                }
              });
            } else if (response.data.succCnt == -999) {
              swal({
                title: '등록 실패',
                text: '등록에 실패하였습니다(개인정보 또는 비속어 포함)',
                // icon: vm.fnOnLoadSwalImageData('error'),
                buttons: {
                  cancel: {
                    text: "취소",
                    value: false,
                    visible: false,
                  },
                  confirm: {
                    text: "확인",
                    value: true,
                    visible: true,
                  },
                },
                dangerMode: false
              }).then(result => {
                if (result) {
                  return false;
                }
              });
            }
          }).catch(function (ex) {
            console.log(ex);
          });
        }else{
          return false;
        }
      });

    },



    maskName(name) {
      if (!name) return '';
      const firstChar = name.charAt(0); // 첫 번째 글자
      const maskedChars = '*'.repeat(name.length - 1); // 나머지 글자를 *로 마스킹
      return firstChar + maskedChars;
    },
    goToRemark(link) {
      window.open(link);
    },

    ztf: function (t) {
      let vm = this;
      vm.viewModel.zf = t
    },
    zta: function () {
      let vm = this;
      vm.viewModel.zf--
      if (vm.viewModel.zf < 1) vm.viewModel.zf = 1
    },
    ztb: function () {
      let vm = this;
      vm.viewModel.zf++
      if (vm.viewModel.zf > vm.viewModel.zt) vm.viewModel.zf = vm.viewModel.zt
    },
    fnOnLoadKakaoContent: function (value) {
      let _atag = value.replace(/<(\/a|a|\/img|img|\/br|br|\/p|p|\/span|span)([^>]*)>/gi, "");
      if (_atag == null) {
        return '';
      }
      let _nbsptag = _atag.replace(/&nbsp;/gi, "");
      if (_nbsptag == null) {
        return '';
      }
      let _httptag = _nbsptag.replace(/^(((http(s?))\:\/\/))([0-9a-zA-Z\-]+\.)+[a-zA-Z]{2,6}(\:[0-9]+)?(\/\S*)?/, "");
      if (_httptag == null) {
        return '';
      }
      return (_httptag.length >= 200) ? _httptag.substring(0, 200).concat('...') : _httptag;
    },
    fnSetPager: function (totalCount, etc) {
      let vm = this;
      vm.viewModel.pager.etc = etc
      vm.viewModel.pager.totalSize = totalCount;
      vm.viewModel.pager.pageNum = (vm.viewModel.pager.pageNo * vm.viewModel.pager.rowSize) - vm.viewModel.pager.rowSize;
      Pager.props = Pager.methods.createPager(vm.viewModel.pager, vm, "list");
    },
    fnRemoveHTML:function(text){
      if(text == null || text == "") return text;
      text = text.replace(/<[^>]*>/g, '');
      text = text.replace(/<br\/>/ig, "\n");
      text = text.replace(/<(\/)?([a-zA-Z]*)(\s[a-zA-Z]*=[^>]*)?(\s)*(\/)?>/ig, "");
      return text;
    },
    fnHideLikeList: function (brdUidKey) {
      $("div .likeList").hide();
    },
    extractContent(s) {
      var span = document.createElement('span');
      span.innerHTML = s;
      return span.textContent || span.innerText;
    },
    onEditorChange: function (event) {
      if (this.insertSenate && this.$refs.myQuillEditor) {
        this.insertSenate.content1 = event.html;
      } else if (this.insertVoice) {
        this.insertVoice.content1 = event.html;
      }
      this.$emit('getEditorInfo', event);
    },
    onEditorVoiceChange: function (event) {
      this.insertVoice.content1 = event.html;
      this.$emit('onEditorVoiceChange', event);

      console.log(this.insertVoice.content1);
    },

    fnOnClickSharePop: function () {
      this.isShare = true;
    },
    fnOnClickCloseSharePop: function () {
      this.isShare = false;
    }
    , fnOnClickKakaoShare: function () {
      let vm = this;
      const uid = $("#brdUidKey").val();
      let shareUrl = '';

      // 현재 페이지 경로 기반으로 공유 URL 구성
      const path = window.location.pathname || '';
      let param = {};
      let urlAddress = '';
      Axios.post("/api/url/address", param).then(function (response) {
        urlAddress = response.data.urlName || window.location.origin;

        if (path.indexOf('/customer/policy/policyNoticeDetail') > -1) {
          shareUrl = urlAddress + '/customer/policy/policyNoticeDetail?brdUidKey=' + uid + '&shared=Y';
        } else if (path.indexOf('/customer/policy/proposalDetail') > -1) {
          shareUrl = urlAddress + '/customer/policy/proposalDetail?brdUidKey=' + uid + '&shared=Y';
        } else {
          // fallback: 현재 URL에 shared 추가
          const loc = window.location.href.split('#')[0];
          shareUrl = loc + (loc.indexOf('?') > -1 ? '&' : '?') + 'shared=Y';
        }

        vm.fnShareLog(uid);

        let imagePath = urlAddress + '/design/common/images/sub/img_noimg.png';
        if (vm.viewModel && Array.isArray(vm.viewModel.fileImgList) && vm.viewModel.fileImgList.length > 0) {
          const first = vm.viewModel.fileImgList[0];
          if (first.fileUrl) imagePath = urlAddress + '/' + first.fileUrl;
        }

        Share.methods.fnOnCreateKakaoShareUrl(
          shareUrl,
          (vm.viewModel && vm.viewModel.detail ? vm.viewModel.detail.title : document.title) || '',
          imagePath,
          '', '', '', '', ''
        );
      });
    }
    , fnOnClickNaverShare: function () {
      let vm = this;
      const uid = $("#brdUidKey").val();
      let shareUrl = '';

      let param = {};
      let urlAddress = '';
      Axios.post("/api/url/address", param).then(function (response) {
        urlAddress = response.data.urlName || window.location.origin;

        const path = window.location.pathname || '';
        if (path.indexOf('/customer/policy/policyNoticeDetail') > -1) {
          shareUrl = urlAddress + '/customer/policy/policyNoticeDetail?brdUidKey=' + uid + '&shared=Y';
        } else if (path.indexOf('/customer/policy/proposalDetail') > -1) {
          shareUrl = urlAddress + '/customer/policy/proposalDetail?brdUidKey=' + uid + '&shared=Y';
        } else {
          const loc = window.location.href.split('#')[0];
          shareUrl = loc + (loc.indexOf('?') > -1 ? '&' : '?') + 'shared=Y';
        }

        vm.fnShareLog(uid);

        let imagePath = urlAddress + '/design/common/images/sub/img_noimg.png';
        if (vm.viewModel && Array.isArray(vm.viewModel.fileImgList) && vm.viewModel.fileImgList.length > 0) {
          const first = vm.viewModel.fileImgList[0];
          if (first.fileUrl) imagePath = urlAddress + '/' + first.fileUrl;
        }

        Share.methods.fnOnCreateNaverShareUrl(
          shareUrl,
          (vm.viewModel && vm.viewModel.detail ? vm.viewModel.detail.title : document.title) || '',
          imagePath
        );
      });
    }
    , fnOnClickFacebookShare: function () {
      let vm = this;
      const uid = $("#brdUidKey").val();
      let shareUrl = '';

      let param = {};
      let urlAddress = '';
      Axios.post("/api/url/address", param).then(function (response) {
        urlAddress = response.data.urlName || window.location.origin;

        const path = window.location.pathname || '';
        if (path.indexOf('/customer/policy/policyNoticeDetail') > -1) {
          shareUrl = urlAddress + '/customer/policy/policyNoticeDetail?brdUidKey=' + uid + '&shared=Y';
        } else if (path.indexOf('/customer/policy/proposalDetail') > -1) {
          shareUrl = urlAddress + '/customer/policy/proposalDetail?brdUidKey=' + uid + '&shared=Y';
        } else {
          const loc = window.location.href.split('#')[0];
          shareUrl = loc + (loc.indexOf('?') > -1 ? '&' : '?') + 'shared=Y';
        }

        vm.fnShareLog(uid);

        Share.methods.fnOnCreateFacebookShareUrl(shareUrl);
      });
    }
    , fnOnClickLinkShare: function () {
      let vm = this;
      const uid = $("#brdUidKey").val();
      let shareUrl = '';

      let param = {};
      let urlAddress = '';
      Axios.post("/api/url/address", param).then(function (response) {
        urlAddress = response.data.urlName || window.location.origin;

        const path = window.location.pathname || '';
        if (path.indexOf('/customer/policy/policyNoticeDetail') > -1) {
          shareUrl = urlAddress + '/customer/policy/policyNoticeDetail?brdUidKey=' + uid + '&shared=Y';
        } else if (path.indexOf('/customer/policy/proposalDetail') > -1) {
          shareUrl = urlAddress + '/customer/policy/proposalDetail?brdUidKey=' + uid + '&shared=Y';
        } else {
          const loc = window.location.href.split('#')[0];
          shareUrl = loc + (loc.indexOf('?') > -1 ? '&' : '?') + 'shared=Y';
        }

        vm.fnShareLog(uid);

        let popupUrl = '/customer/activity/share/link?url=' + encodeURIComponent(shareUrl);
        window.open(popupUrl, '공유하기', 'width=550, height=550, toolbar=no, menubar=no, scrollbars=no, resizable=no');
      });
    }
    , fnShareLog(uidKey) {
      Axios.post("/api/logCud/insert", {
        paramUid: uidKey,
        statusCode: "share",
        version: "insert"
      }).then(function (response) {
        // no-op
      });
    }
    , fnSetCode: function (_code) {
      let vm = this;
      let param = {
        searchCode: _code
      };

      Axios.post("/api/expinfo/code", param).then(function (response) {
        vm.declareList = response.data.expinfoCodeList;

      }).catch(function (ex) {
        console.log(ex);
      });
    }
    ,fnOnDeclarePopup() {
      let vm = this;
      let _userKey = $("#userKey").val();

      if (_userKey != null && _userKey != "") {
        let param = {
          uidKey: $("#uid").val(),
          userKey: _userKey
        };

        Axios.post("/api/expinfo/isDeclare", param).then(function (response) {
          let result = response.data.result;
          if (result == 1) {
            vm.fnSwalAlert("접수된 신고 이력이 있습니다.");
          } else {
            vm.isDeclare = true;
          }
        }).catch(function (ex) {
          console.log(ex);
        });
      } else {
        swal({
          text: "신고하기는 로그인한 회원만 가능합니다.\n 로그인하시겠습니까?",
          closeOnClickOutside: false,
          // // icon: vm.fnOnLoadSwalImageData('info'),
          buttons: {
            confirm: {
              text: "확인",
              value: true,
              visible: true
            },
            cancel: {
              text: "취소",
              value: false,
              visible: true
            }
          }
        }).then(result => {
          if (result) {
            location.href = "/youthnavi/signup/login?returnURI=" + encodeURIComponent(window.location.pathname + window.location.search);
          }
        });
      }
    },
    fnOffDeclarePopup() {
      let vm = this;
      vm.isDeclare = false;
      vm.declareReportValues = "";
      vm.declareReportEtc = "";
    },
    fnInsertDeclare() {
      let vm = this;

      let param = {
        userId: $("#userId").val(),
        userKey: $("#userKey").val(),
        boardUid: $("#uid").val(),
        reportKey: vm.declareReportCode,
        reportEtc: vm.declareReportEtc,
        boardCtg: "RCMNVYTHNV00200"
      };

      let declareReportCode = vm.declareReportCode == "" ? false : true;

      if (!declareReportCode) {
        vm.fnSwalAlert('신고사유가 선택되지않았습니다.');
        return false;
      } else if (vm.declareReportCode == "RPTNVYTHNV00400") {
        let declareReportEtc = vm.declareReportEtc == "" ? false : true;
        if (!declareReportEtc) {
          vm.fnSwalAlert('기타항목이 입력되지않았습니다.');
          return false;
        }
      }

      Axios.post("/api/expinfo/insertDeclare", param).then(function (response) {
        let result = response.data.result;
        if (result > 0) {
          vm.fnSwalSuccess("신고가 접수되었습니다.", setTimeout(function () {
            vm.fnOffDeclarePopup();
          }, 1500));
        } else if (result == -999) {
          swal({
            title: '접수 실패',
            text: '신고접수에 실패하였습니다(개인정보 또는 비속어 포함)',
            // icon: vm.fnOnLoadSwalImageData('error'),
            buttons: {
              cancel: {
                text: "취소",
                value: false,
                visible: false
              },
              confirm: {
                text: "확인",
                value: true,
                visible: true
              },
            },
            dangerMode: false
          }).then(result => {
            if (result) {
              return false;
            }
          });
        } else {
          vm.fnSwalAlert("오류가 발생하였습니다.");
        }
      }).catch(function (ex) {
        console.log(ex);
        vm.fnSwalAlert("오류가 발생하였습니다.");
      });
    }
  }
});

